import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../routes/routes';
import { Navbar as BsNavbar, Nav, NavDropdown, Container, Button } from 'react-bootstrap';
import { useAuth } from '../../providers/AuthProvider';
import { ConfigReader } from '../../config/ConfigReader';
import { GitMerge, CheckCircle, Gift, Edit, Package, Users, Award, Bot } from 'lucide-react';

export const Navbar = () => {
  const [expanded, setExpanded] = useState(false);
  const { user, logout } = useAuth();
  const config = ConfigReader.getInstance().getConfig();

  const handleToggle = () => setExpanded(!expanded);
  const handleClose = () => setExpanded(false);

  return (
    <BsNavbar bg="dark" variant="dark" expand="lg" expanded={expanded} onToggle={handleToggle} className="mb-3">
      <Container fluid>
        <BsNavbar.Brand as={Link} to={ROUTES.home}>
          SkinSeoul
        </BsNavbar.Brand>
        <BsNavbar.Toggle aria-controls="navbar-nav" />
        <BsNavbar.Collapse id="navbar-nav" role="navigation">
          <Nav className="me-auto">
            <NavDropdown title="Operation AI" id="ai-operations-dropdown">
              <NavDropdown.Item as={Link} to={ROUTES.ai.agentRegistry} onClick={handleClose}>
                <Bot size={16} className="me-2" />
                Agent Registry
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Header>Competitor Product Match</NavDropdown.Header>
              <NavDropdown.Item as={Link} to={ROUTES.competitor.matchStatus} onClick={handleClose}>
                AI Match Competitor Status
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.competitor.matchSKU.default} onClick={handleClose}>
                Review AI Matched Product
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Header>Product Sourcing</NavDropdown.Header>
              <NavDropdown.Item as={Link} to={ROUTES.sourcing.matching} onClick={handleClose}>
                <GitMerge size={16} className="me-2" />
                GP-CP Matching
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.sourcing.matched} onClick={handleClose}>
                <CheckCircle size={16} className="me-2" />
                GP-CP Matched List
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.sourcing.ssReMatching} onClick={handleClose}>
                <GitMerge size={16} className="me-2" />
                SS CP Re-Matching
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.sourcing.scrapeBatch} onClick={handleClose}>
                <Gift size={16} className="me-2" />
                Scrape CP Batch
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Catalog Management" id="catalog-management-dropdown">
              <NavDropdown.Header>Product Management</NavDropdown.Header>
              <NavDropdown.Item as={Link} to={ROUTES.catalog.cmWorkflow} onClick={handleClose}>
                <Package size={16} className="me-2" />
                CM Workflow
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.catalog.ssEditor} onClick={handleClose}>
                <Edit size={16} className="me-2" />
                SS Editor
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Header>Library</NavDropdown.Header>
              <NavDropdown.Item as={Link} to={ROUTES.category.ingredient.default} onClick={handleClose}>
                Ingredient Management
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="OMS Center" id="oms-center-dropdown">
              <NavDropdown.Item as={Link} to={ROUTES.oms.orders} onClick={handleClose}>
                Order Management Dashboard
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.oms.fulfillment} onClick={handleClose}>
                Order Fulfillment Dashboard
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Header>WMS</NavDropdown.Header>
              <NavDropdown.Item as={Link} to={ROUTES.oms.wms.viewOrders} onClick={handleClose}>
                View Orders
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.oms.wms.stock} onClick={handleClose}>
                Stock Status
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.oms.wms.readyToBeOutbonded} onClick={handleClose}>
                Ready to be Outbonded
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="Site Management" id="site-management-dropdown">
              <li className="dropdown-submenu">
                <span className="dropdown-item dropdown-toggle">Banner</span>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to={ROUTES.banner.upload} onClick={handleClose}>
                      Banner Upload
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to={ROUTES.banner.list} onClick={handleClose}>
                      Banner List
                    </Link>
                  </li>
                </ul>
              </li>
              <NavDropdown.Item as={Link} to={ROUTES.review.default} onClick={handleClose}>
                Review Management
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.siteManagement.cache} onClick={handleClose}>
                Invalidate Site Cache
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.siteManagement.campaigns} onClick={handleClose}>
                Campaigns
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.siteManagement.shipping} onClick={handleClose}>
                Shipping Policies
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="System Management" id="system-management-dropdown">
              <NavDropdown.Item as={Link} to={ROUTES.systemManagement.cronJobs} onClick={handleClose}>
                CronJobs
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.systemManagement.redirectConfiguration} onClick={handleClose}>
                Redirect Configuration
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="Customer Management" id="customer-management-dropdown">
              <NavDropdown.Header>Loyalty Program</NavDropdown.Header>
              <NavDropdown.Item as={Link} to={ROUTES.customer.loyalty} onClick={handleClose}>
                <Users size={16} className="me-2" />
                Customer Loyalty
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={ROUTES.customer.tierManagement} onClick={handleClose}>
                <Award size={16} className="me-2" />
                Tier Management
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link href={config.wpAdminUrl} target="_blank" rel="noopener noreferrer" onClick={handleClose}>
              SkinSeoul WP Admin
            </Nav.Link>
          </Nav>
          {user && (
            <Nav>
              <Nav.Item className="d-flex align-items-center">
                <img
                  src={user.picture}
                  alt="Profile"
                  className="rounded-circle me-2"
                  style={{ width: '30px', height: '30px' }}
                />
                <span className="text-light me-3">{user.name}</span>
                <Button variant="outline-light" size="sm" onClick={logout}>
                  Logout
                </Button>
              </Nav.Item>
            </Nav>
          )}
        </BsNavbar.Collapse>
      </Container>
    </BsNavbar>
  );
};

export default Navbar;
